import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/auth/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import FloatingWA from "@/components/FloatingWA";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Packages from "@/pages/Packages";
import PackageDetail from "@/pages/PackageDetail";
import Gallery from "@/pages/Gallery";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import HajiKhusus from "@/pages/HajiKhusus";
import UstadzDetail from "@/pages/UstadzDetail";
import JamaahDetail from "@/pages/JamaahDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminLayout from "@/components/admin/AdminLayout";
import {
  AdminDashboardPage, AdminBookingsPage, AdminPostersPage, AdminDocumentsPage,
  AdminPaymentsPage, AdminContentPage, AdminPackagesPage, AdminJamaahPage, AdminSettingsPage, AdminBroadcastPage, AdminManasikPage,
  AdminUstadzPage, AdminRemindersPage, AdminMessagesPage, AdminAlumniPage,
} from "@/pages/admin/AdminPages";
import MyBookings from "@/pages/MyBookings";
import RegisterJamaah from "@/pages/RegisterJamaah";
import PosterAdmin from "@/pages/PosterAdmin";
import AlumniTestimoni from "@/pages/AlumniTestimoni";
import AuthCallback, { ProtectedRoute } from "@/auth/AuthCallback";

function AppRouter() {
  const location = useLocation();
  // Detect session_id during render to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      {/* Standalone password-protected admin page for Poster Promo (ADMIN_PASSWORD env) */}
      <Route path="/admin/poster" element={<PosterAdmin />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboardPage />} />
        <Route path="bookings" element={<AdminBookingsPage />} />
        <Route path="paket" element={<AdminPackagesPage />} />
        <Route path="jamaah" element={<AdminJamaahPage />} />
        <Route path="jamaah/:userId" element={<JamaahDetail />} />
        <Route path="posters" element={<AdminPostersPage />} />
        <Route path="dokumen" element={<AdminDocumentsPage />} />
        <Route path="pembayaran" element={<AdminPaymentsPage />} />
        <Route path="konten" element={<AdminContentPage />} />
        <Route path="ustadz" element={<AdminUstadzPage />} />
        <Route path="reminders" element={<AdminRemindersPage />} />
        <Route path="messages" element={<AdminMessagesPage />} />
        <Route path="pengaturan" element={<AdminSettingsPage />} />
        <Route path="broadcast" element={<AdminBroadcastPage />} />
        <Route path="manasik" element={<AdminManasikPage />} />
        <Route path="alumni" element={<AdminAlumniPage />} />
      </Route>
      <Route path="/my-bookings" element={<ProtectedRoute><MyBookings /></ProtectedRoute>} />
      <Route path="/testimoni/:bookingId" element={<AlumniTestimoni />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/packages/:slug" element={<PackageDetail />} />
        <Route path="/daftar/:slug" element={<RegisterJamaah />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogDetail />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/haji-khusus" element={<HajiKhusus />} />
        <Route path="/ustadz/:slug" element={<UstadzDetail />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <AppRouter />
            <FloatingWA />
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
